const includes = (
    source: string[],
    items: string[],
    options: { type: "EVERY" | "SOME" } = { type: "EVERY" },
) => {
    switch (options.type) {
        case "EVERY":
            return items.every(item => source.includes(item));
        case "SOME":
            return items.some(item => source.includes(item));
    }
};

export { includes };
